export default "__VITE_ASSET__BAhiFg2v__";